<template>
  <div class="payOrder">
    <!-- 头部登录 -->
    <Header-Top></Header-Top>
    <div class="main w">
      <div class="main-top">
        <img
          src="../../assets/images/home/logo1.png"
          alt=""
          style="vertical-align: sub; width: 150px; height: 39px"
        />
        <span class="span-2">收银台</span>
        <span class="guarantee">正见 · 正心 · 正品</span>
      </div>
      <!-- 订单提交 -->
      <div class="main-center">
        <div class="main-center-fl">
          <div>
            <span class="iconfont icon-a-lujing2281"></span>
          </div>
          <div class="span-3">
            <p>
              订单已提交，请在
              <i>{{ this.minute }}分{{ this.second }}秒</i>
              之内完成支付，否则订单会被<i>自动取消</i>！
            </p>
            <!-- <div class="span-4">
              <span class="iconfont icon-a-zu417"></span>请在
              <i>{{ this.minute }}分:{{ this.second }}秒</i>
              之内完成支付，否则订单会被<i style="font-weight:700">自动取消</i> 。
            </div> -->
          </div>
        </div>
        <div class="main-center-fr">
          应付金额：<i>&yen;{{ totalPrice || 0 }}</i>
        </div>
      </div>
      <!-- 支付方式 -->
      <div class="main-pay">
        <p>支付方式</p>
        <div class="main_pay_zf">
          <div class="paymentfs">
            <!-- <RadioGroup v-model="paymentType">
            <Radio
              :label="item.itemValueOne"
              v-for="item in patmentList"
              :key="item.itemValueOne"
            >
              <span></span>
              <span>{{ item.itemName }}</span>
            </Radio>
          </RadioGroup> -->
            <div class="payment">
              <!-- <div class="offline">
                <span>
                  <img class="imgs1" src="@/assets/images/组 773.png" alt="" />
                </span>
                <RadioGroup v-model="single">
                  <Radio label="1">线下转账</Radio>
                </RadioGroup>
              </div> -->
              <div class="suspendz">
                <span>
                  <!-- <img class="imgs2" src="@/assets/images/组 778.png" alt="" /> -->
                </span>
                <RadioGroup v-model="single" @on-change="changeRadio">
                  <img src="@/assets/images/组 773.png" alt="" />
                  <Radio label="1" style="margin-right: 39px">线下转账</Radio>
                  <img src="@/assets/images/组 778.png" alt="" />
                  <Radio label="2" :disabled="!disabled">挂账</Radio>
                </RadioGroup>
              </div>
            </div>
            <div class="reminder">
              非自营、非联盟商品不能使用挂账，请分开结算
            </div>
          </div>
          <!-- <div class="singlespan-btn"><i @click="payment">确认支付</i></div> -->
          <div class="span-btn">
            <Button @click="payment" type="error" :loading="loading"
              >确认付款</Button
            >
          </div>
        </div>
      </div>
      <!-- 支付明细 -->
      <div class="main-payorder">
        <div class="main-payorder-t">
          支付明细
          <!-- 这是最近改的 -->
          <!-- <span
            class="iconfont icon-a-lujing290"
            @click="showAll = !showAll"
          ></span> -->
          <!-- 之前汪倩写的 -->
          <!-- <span
            class="iconfont icon-a-lujing268"
            v-if="!isShowAll && !isRoll"
            @click="packUp"
          ></span> -->
        </div>
        <div class="detail" v-for="i in showList" :key="i.id">
          <div class="w12" v-show="!isShow">
            <p class="w1">
              {{ i.name }} <i>￥{{ i.categoryAmount }}</i>
            </p>
            <p class="w13">可用额度 ：￥{{ i.credit }}</p>
          </div>

          <div class="w14">
            <div v-for="item in i.orderQueryVOList" :key="item.id" class="w11">
              <router-link
                rel="opener"
                :to="{
                  path: '/orderDetails',
                  query: { id: item.code, orderId: item.code.substr(1) }
                }"
              >
                <span class="span_1">订单编号：</span>{{ item.code }}
              </router-link>
              <p>
                <span class="span_1"
                  >卖&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;家:</span
                >{{ item.sellerTenantName }}
              </p>
              <p><span class="span_1">交易时间：</span>{{ item.createTime }}</p>
              <p>
                <span class="span_1">交易金额:</span
                ><span>&yen; {{ item.money }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 200px"></div>

    <Spin size="large" fix v-if="spinShow"></Spin>
  </div>
</template>

<script>
import HeaderTop from '../base/common/header-top.vue'
import { getOrders, getDictionariesItems, payment } from '../../api/payOrder'
export default {
  name: 'payOrder',
  components: { HeaderTop },
  data() {
    return {
      spinShow: true,
      isShow: true,
      orderList: '', // 接口返回所有数据
      disabled: '',
      loading: false,
      ordeNumber: [],
      totalPrice: '',
      paymentType: '1',
      showList: '', // 展示订单
      patmentList: [], // 支付方式
      showAll: false,
      minutes: '', //倒计时分
      seconds: '', //倒计时秒
      ordersIds: [], // 批量订单id
      single: '1', // 线下转账
      // single1: '', //挂账
      balance: false
    }
  },
  created() {
    this.ordeNumber = JSON.parse(this.$route.query.ordeNumber)
    this.getOrders()
  },
  methods: {
    // 获取订单信息
    async getOrders() {
      // 1-获取支付状态
      // const res = await getDictionariesItems(['ZFFS'])
      // console.log(res)
      // if (res.code == 0) {
      //   this.patmentList = res.data.ZFFS
      // this.ordeNumber = ['1481214854604136449']
      // 1-2获取支付订单
      const res = await getOrders(this.ordeNumber)
      console.log(res)
      if (res.status) {
        // res.data.second = null
        if (res.data.second == null) {
          this.$router.push({
            path: '/payStatus',
            query: {
              status: 0
            }
          })
        } else {
          this.orderList = JSON.parse(JSON.stringify(res.data))
          this.totalPrice = this.orderList.totalPrice
          this.showList = this.orderList.orderCategoryVOList
          this.ordersIds = this.orderList.ordersIds
          this.minutes = this.orderList.minute
          // this.minutes = null
          this.seconds = this.orderList.second
          // this.seconds = null
          this.disabled = Boolean(this.orderList.hasCredit)
        }
      } else {
        this.$router.push({
          path: '/payStatus',
          query: {
            status: 0
          }
        })
      }
      this.spinShow = false
      // }
    },
    num: function (n) {
      return n < 10 ? '0' + n : '' + n
    },
    add: function () {
      var _this = this
      var time = window.setInterval(function () {
        if (_this.seconds === 0 && _this.minutes !== 0) {
          _this.seconds = 59
          _this.minutes -= 1
        } else if (_this.minutes === 0 && _this.seconds === 0) {
          _this.seconds = 0
          // _this.$Message.warning('页面已过期，进入我的【订单页面】重新支付')
          window.clearInterval(time)
          _this.$router.push({
            path: '/payStatus',
            query: {
              status: 0
            }
          })
        } else {
          _this.seconds -= 1
        }
      }, 1000)
    },
    // 订单支付方式切换
    changeRadio(val) {
      if (val == 2) {
        this.isShow = false
      } else {
        this.isShow = true
      }
      console.log(val)
    },
    // 确认支付
    async payment() {
      this.loading = true
      const res = await payment({
        paymentType: this.single,
        ordersIds: this.ordersIds
      })
      if (res.status) {
        this.loading = false
        this.$router.push({
          path: '/payStatus',
          query: {
            status: 1
          }
        })
      } else {
        this.loading = false
        this.$router.push({
          path: '/payStatus',
          query: {
            status: 2
          }
        })
      }
    }
  },
  computed: {
    // 批量订单的显示与隐藏
    // orderList() {
    //   if (this.showAll == false) {
    //     var orderList = []
    //     if (this.showList.length > 3) {
    //       orderList = this.showList.slice(0, 3)
    //     } else {
    //       orderList = this.showList
    //     }
    //     return orderList
    //   } else {
    //     return this.showList
    //   }
    // },
    second: function () {
      return this.num(this.seconds)
    },
    minute: function () {
      return this.num(this.minutes)
    }
  },
  watch: {
    second: {
      handler(newVal) {
        this.num(newVal)
      }
    },
    minute: {
      handler(newVal) {
        this.num(newVal)
      }
    }
  },
  mounted() {
    this.add()
  }
}
</script>
<style lang="less" scoped>
.payOrder {
  background-color: #f5f5f8;
  .w {
    width: 1200px;
    margin: 0 auto;
  }
  .main {
    padding-top: 113px;
    .main-top {
      clear: both;
      padding-bottom: 10px;
      border-bottom: 3px solid #377cf1;
      .span-2 {
        width: 60px;
        height: 20px;
        font-size: 20px;
        margin-left: 13px;
        margin-right: 23px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        line-height: 0px;
        color: #505050;
      }
      .guarantee {
        width: 142px;
        height: 20px;
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 0px;
        color: #8b8c94;
        opacity: 1;
      }
    }
    .main-center {
      height: 148px;
      display: flex;
      justify-content: space-between;
      .main-center-fl {
        display: flex;
        div:first-child {
          padding-top: 15px;
          span {
            font-size: 60px;
            color: #35b94f;
          }
        }
        .span-3 {
          margin-left: 11px;
          padding-top: 47px;
          p {
            font-size: 18px;
            color: #505050;
            i {
              color: #ff5e00;
            }
          }
          .span-4 {
            display: flex;
            align-items: center;
            width: 400px;
            height: 30px;
            font-size: 14px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            line-height: 0px;
            color: #505050;
            margin-top: 9px;
            padding: 7px 0 6px 8px;
            border: 1px solid #ff8a24;
            background-color: #fff7f2;
            .icon-a-zu417 {
              font-size: 12px;
              padding-right: 4px;
            }
            .icon-a-zu417,
            i {
              color: #ff5e00;
            }
          }
        }
      }
      .main-center-fr {
        height: 24px;
        line-height: 24px;
        font-size: 24px;
        font-family: Source Han Sans CN;
        color: #555555;
        font-weight: bold;
        margin-top: 47px;
        i {
          color: #f62b4e;
        }
      }
    }
    .main-pay {
      p {
        width: 80px;
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #505050;
        opacity: 1;
      }
      .main_pay_zf {
        background-color: #ffffff;
        border: 1px solid #e2e2e2;
        .paymentfs {
          display: flex;
          // justify-content: center;
          // align-items: center;
          flex-direction: column;
          width: 1200px;
          height: 77px;
          padding-left: 34px;
          padding-top: 14px;
          border-bottom: 1px solid #e2e2e2;
          .payment {
            display: flex;
            height: 38px;
            .suspendz {
              display: flex;
              align-items: center;
              img {
                vertical-align: middle;
                width: 38px;
                height: 38px;
                margin-right: 8px;
              }
            }
          }
          .reminder {
            margin-left: 158px;
            width: 263px;
            font-size: 12px;
            margin-top: 4px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #c2c2c2;
          }
        }
        .ivu-radio-group {
          width: 100%;
        }
        .ivu-radio-group-item {
          margin-right: 0px;
        }
        .span-btn {
          display: flex;
          align-items: center;
          height: 80px;
          border-radius: 2px;
          .ivu-btn {
            font-size: 18px;
            color: #ffffff;
            height: 40px;
            background-color: #f62b4e;
            margin-left: 31px;
          }
          /deep/ .ivu-btn > span {
            font-size: 18px;
          }
        }
      }
    }
    .main-payorder {
      margin-top: 30px;
      .main-payorder-t {
        width: 80px;
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #505050;
        opacity: 1;
        // font-size: 14px;
        // font-weight: bold;
        // color: #434343;
        // padding: 13px 0 13px 15px;
        // background-color: #f6f6f6;
        // .icon-a-lujing290 {
        //   font-size: 12px;
        //   color: #9d9d9d;
        //   padding-left: 6px;
        //   cursor: pointer;
        // }
      }
      .detail {
        background-color: #ffffff;
        padding: 19px 0 19px 40px;
        .w12 {
          .w1 {
            font-size: 16px;
            font-weight: bold;
            color: #505050;
            i {
              font-size: 18px;
              font-weight: bold;
              color: #f62b4e;
              padding-left: 50px;
            }
          }
          .w13 {
            font-size: 14px;
            color: #505050;
            padding: 16px 0 8px 0;
          }
        }

        .w14 {
          width: 780px;
          display: flex;
          flex-flow: row wrap;
          justify-content: space-between;
          .w11 {
            background-color: #f6f6f6;
            margin-right: 20px;
            margin-bottom: 20px;
            // display: inline-block;
            width: 360px;
            height: 140px;
            padding: 21px 22px 21px 22px;
            font-size: 14px;
            color: #505050;

            a:hover {
              color: #377cf1;
            }
            p {
              font-size: 14px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              // line-height: 0px;
              color: #505050;

              // font-size: 14px;
              // color: #505050;
              padding-top: 5px;
            }
            .span_1 {
              display: inline-block;
              width: 70px;
              height: 19px;
            }
          }
        }
        // a {

        // }

        // border: 1px solid #e2e2e2;
        // padding-bottom: 40px;
        // 自营挂账
        // .proprietarygz {
        //   display: flex;
        //   padding: 19px 0 0 40px;
        //   .proprietarygz_top {
        //     margin-right: 50px;
        //     .zygz {
        //       width: 64px;
        //       height: 16px;
        //       font-size: 16px;
        //       margin-bottom: 16px;
        //       font-family: Source Han Sans CN;
        //       font-weight: bold;
        //       color: #505050;
        //     }
        //     .ed {
        //       font-size: 14px;
        //       font-family: Source Han Sans CN;
        //       font-weight: 400;
        //       color: #505050;
        //     }
        //   }
        //   .kyed {
        //     .je {
        //       width: 81px;
        //       height: 18px;
        //       font-size: 18px;
        //       font-family: Source Han Sans CN;
        //       font-weight: bold;
        //       color: #f62b4e;
        //       margin-bottom: 13px;
        //     }
        //     .edq {
        //       background: #ffffff;
        //       border: 1px solid #f62b4e;
        //       border-radius: 2px;
        //       .insufficient {
        //         width: 75px;
        //         height: 12px;
        //         font-size: 12px;
        //         font-family: Source Han Sans CN;
        //         font-weight: 400;
        //         line-height: 0px;
        //         color: #f62b4e;
        //         margin-left: 4px;
        //       }
        //     }
        //   }
        // }
      }
      // ul {
      //   display: flex;
      //   flex-wrap: wrap;
      //   margin-top: 8px;
      //   margin-left: 40px;
      //   // margin-bottom: 40px;
      //   // height: 220px;
      //   // overflow-y: hidden;
      //   transition: height 0.3s; // 动画效果
      //   // li:nth-child(even) {
      //   //   margin-left: 0.6%;
      //   //   margin-right: 0.6%;
      //   // }
      //   li {
      //     width: 360px;
      //     height: 140px;
      //     background: #f6f6f6;
      //     padding: 21px 0 21px 22px;
      //     margin-right: 20px;
      //     // width: 31.5%;
      //     // background-color: #f6f6f6;
      //     // // margin-left: 1.7%;
      //     // margin-bottom: 40px;
      //     // padding: 23px 33px 22px;
      //     a {
      //       font-size: 14px;
      //       font-family: Source Han Sans CN;
      //       font-weight: 400;
      //       color: #505050;
      //       // font-size: 14px;
      //       // color: #505050;
      //       // padding-top: 12px;
      //     }
      //     a:hover {
      //       color: #377cf1;
      //     }
      //     p {
      //       font-size: 14px;
      //       font-family: Source Han Sans CN;
      //       font-weight: 400;
      //       // line-height: 0px;
      //       color: #505050;

      //       // font-size: 14px;
      //       // color: #505050;
      //       padding-top: 5px;
      //     }
      //     .span_1 {
      //       display: inline-block;
      //       width: 70px;
      //       height: 19px;
      //     }
      //   }
      // }
    }
  }
}
// .fz14 {
//   font-size: 14px;
// }
// .res90 {
//   color: #e90d0d;
// }
// .ml30 {
//   margin-left: 30px;
// }
// .ml5 {
//   margin-left: 5px;
// }
</style>
